exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.12@core-js/library/modules/_wks-ext.js
// module id = 82
// module chunks = 0